var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{displayHighFive: _vm.displayHighFive},attrs:{"id":"HighFiveDemo"}},[_c('i',{staticClass:"fa-solid fa-hand-sparkles"}),_vm._v(" Katie sent you a high five ")])}
var staticRenderFns = []

export { render, staticRenderFns }